import styled from '@emotion/styled';
import { Button, Dialog, DialogActions as _DialogActions, DialogContent, Typography } from '@material-ui/core';
import Publish from '@material-ui/icons/Publish';
import { createElement, FC, Fragment, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_UNIT } from '../../constant/spacing';
import ButtonWithIcon from '../primitive/ButtonWithIcon';
import LfToBr from '../primitive/LfToBr';

const ObsoletedProjectTypeDialogAndButton: FC<{
  className?: string;
}> = ({ className }) => {
  const [open, setOpen] = useState(false);
  const openCallback = useCallback(() => setOpen(true), []);
  const closeCallback = useCallback(() => setOpen(false), []);

  return (
    <>
      <ButtonWithIcon icon={Publish} color="primary" variant="contained" onClick={openCallback}>
        <FormattedMessage id="project_editing_page.preview.buttons.submit" />
      </ButtonWithIcon>
      <Dialog open={open} onClose={closeCallback} className={className}>
        <DialogContent>
          <Typography variant="subtitle1" color="textPrimary">
            <FormattedMessage id="obsoleted_project_type_dialog.text">
              {(text: string) => <LfToBr text={text} />}
            </FormattedMessage>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCallback}>
            <FormattedMessage id="obsoleted_project_type_dialog.close" />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const DialogActions = styled(_DialogActions)({
  paddingBottom: SPACING_UNIT,
  paddingRight: SPACING_UNIT,
});

export default ObsoletedProjectTypeDialogAndButton;
